var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.8182C20 19.0232 19.0232 20 17.8182 20L6.18182 20C4.97683 20 4 19.0232 4 17.8182V15.6364C4 15.2347 4.32561 14.9091 4.72727 14.9091C5.12893 14.9091 5.45455 15.2347 5.45455 15.6364L5.45455 17.8182C5.45455 18.2198 5.78016 18.5455 6.18182 18.5455L17.8182 18.5455C18.2198 18.5455 18.5455 18.2198 18.5455 17.8182L18.5455 6.18182C18.5455 5.78016 18.2198 5.45455 17.8182 5.45455L6.18182 5.45455C5.78016 5.45455 5.45455 5.78016 5.45455 6.18182L5.45455 8.36364C5.45455 8.7653 5.12893 9.09091 4.72727 9.09091C4.32561 9.09091 4 8.7653 4 8.36364V6.18182C4 4.97683 4.97684 4 6.18182 4H17.8182C19.0232 4 20 4.97684 20 6.18182L20 17.8182Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1194 11.2727L11.787 9.60517C12.071 9.32115 12.071 8.86067 11.787 8.57665C11.503 8.29263 11.0425 8.29263 10.7585 8.57665L7.84938 11.4857C7.56536 11.7698 7.56536 12.2302 7.84938 12.5143L10.7585 15.4234C11.0425 15.7074 11.503 15.7074 11.787 15.4234C12.071 15.1393 12.071 14.6788 11.787 14.3948L10.1194 12.7273H15.6364C16.038 12.7273 16.3636 12.4017 16.3636 12C16.3636 11.5983 16.038 11.2727 15.6364 11.2727H10.1194Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.5451a9c9876cb3ea8707834ca53cdc0f.svg";
export { ForwardRef as ReactComponent };